@if (redirectPreloaderService.redirectingPreloader) {
  <div class="redirecting-preloader">
    <div class="redirecting-preloader-background"></div>
    <libero-preload-spinner></libero-preload-spinner>
  </div>
}

@if (isNativePhone) {
  <div class="native-safezone-overlay" [ngStyle]="{ 'height.px': nativeSafeZoneService.paddings.top }"></div>
}

<div class="login-page">
  <div class="login-background">
    <div class="logo-container">
      <svg-icon src="assets/logo/logo-white.svg" [svgStyle]="{ 'width.px':330 }"></svg-icon>
    </div>
    <div class="logo-desc">
      {{ 'login.underLogoDescription' | translate }}
    </div>

    <div class="page-description">
      {{ 'login.welcomeDescription' | translate }}
    </div>

    <div class="login-buttons-container">
      @if (isNativePhone) {
        <div
          class="login-btn-container"
          (click)="inAppBrowserAuthService.openInAppBrowser()"
          (keydown.space)="inAppBrowserAuthService.openInAppBrowser()"
          (keydown.enter)="inAppBrowserAuthService.openInAppBrowser()"
          tabindex="0"
          >
          <libero-button data-cy="login-button" label="{{ 'login.loginButtonLabel' | translate }}" btnClasses="btn--primary btn--heading"></libero-button>
        </div>
        <div
          class="login-consult-link"
          (click)="openWorkplace()"
          (keydown.space)="openWorkplace()"
          (keydown.enter)="openWorkplace()"
          tabindex="0"
          >
          {{ 'login.consultLogin' | translate }}
        </div>
      } @else {
        <a class="login-btn-container" href="{{bcasClientLoginUrl}}" data-cy="login-btn-client">
          <libero-button data-cy="login-button" label="{{ 'login.loginButtonLabel' | translate }}" btnClasses="btn--primary btn--heading"></libero-button>
        </a>
        <a class="login-consult-link" href="{{bcasConsultLoginUrl}}" data-cy="login-btn-consult">
          {{ 'login.consultLogin' | translate }}
        </a>
      }
    </div>

    <div class="login-background-mask"></div>
  </div>


</div>